import adhd from '../../assets/track_icons/ADHD.png';
import ai_digital_psychiatry from '../../assets/track_icons/AI_Digital_Psychiatry.png';
import alzheimers from '../../assets/track_icons/Alzheimers.png';
import autism_research from '../../assets/track_icons/Autism_Research.png';
import behavioural_science from '../../assets/track_icons/Behavioural_Science.png';
import genetic_research from '../../assets/track_icons/genetic_research.png';
import dementia from '../../assets/track_icons/Dementia.png';
import education_for_autism from '../../assets/track_icons/Education_For_Autism.png';
import forensic_neuropsychiatry from '../../assets/track_icons/Forensic_Neuropsychiatry.png';
import mental_health from '../../assets/track_icons/Mental_Health.png';
import neurobiology from '../../assets/track_icons/Neurobiology.png';
import neurogenetics from '../../assets/track_icons/Neurogenetics.png';
import neuroscience from '../../assets/track_icons/Neuroscience.png';
import pharmacological_interventions from '../../assets/track_icons/Pharmacological_Interventions.png';
import psychiatry from '../../assets/track_icons/Psychiatry.png';
import psychopharmacology from '../../assets/track_icons/Psychopharmacology.png';
import public_health from '../../assets/track_icons/Public_Health.png';
import rehabilitation from '../../assets/track_icons/Rehabilitation.png';
import sleep_disorders from '../../assets/track_icons/Sleep_Disorders.png';
import trauma from '../../assets/track_icons/Trauma.png';


export const tracks = [
  { name: "ADHD", icon: adhd },
  { name: "AI & Digital Psychiatry", icon: ai_digital_psychiatry },
  { name: "Alzheimers", icon: alzheimers },
  { name: "Autism Research", icon: autism_research },
  { name: "Behavioural Science", icon: behavioural_science },
  { name: "Genetic Research", icon: genetic_research },
  { name: "Dementia", icon: dementia },
  { name: "Education For Autism", icon: education_for_autism },
  { name: "Forensic Neuropsychiatry", icon: forensic_neuropsychiatry },
  { name: "Mental Health", icon: mental_health },
  { name: "Neurobiology", icon: neurobiology },
  { name: "Neurogenetics", icon: neurogenetics },
  { name: "Neuroscience", icon: neuroscience },
  { name: "Pharmacological Interventions", icon: pharmacological_interventions },
  { name: "Psychiatry", icon: psychiatry },
  { name: "Psychopharmacology", icon: psychopharmacology },
  { name: "Public Health", icon: public_health },
  { name: "Rehabilitation", icon: rehabilitation },
  { name: "Sleep Disorders", icon: sleep_disorders },
  { name: "Trauma", icon: trauma },
];
